import { render, staticRenderFns } from "./BoatHouse.vue?vue&type=template&id=dbed4104"
import script from "./BoatHouse.vue?vue&type=script&lang=js"
export * from "./BoatHouse.vue?vue&type=script&lang=js"
import style0 from "./BoatHouse.vue?vue&type=style&index=0&id=dbed4104&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports